import { DateSelectProps } from '@procore/core-react/dist/_typedoc/DateSelect/DateSelect.types.json';
import * as React from 'react';
export default {
  DateSelectProps,
  React
};